import { getTypes } from "./TypeGenerator";

export const CategoryTypes = {
    ...getTypes("CATEGORY"),
};
